<div class="topics-panel" [class.open]="open()">
  <div class="topics-panel-header">
    <span class="panel-title">{{ 'app.components.parentAiAssistant.conversationTopics' | translate }}</span>
    <button type="button" class="close-panel-btn" (click)="close.emit()">✕</button>
  </div>
  @if (isLoadingTopics()) {
    <div class="topics-loading">{{ 'app.components.parentAiAssistant.loadingTopics' | translate }}</div>
  } @else {
    <div class="topics-filters">
      @for (item of topicCounts() | keyvalue; track item.key) {
        <span class="filter-tag"
          >{{ getCategoryLabelKey(item.key) | translate }}
          <span class="tag-count">{{ item.value }}</span></span
        >
      }
    </div>
    <div class="topics-list">
      @for (topic of filteredTopics(); track topic.id) {
        <div
          class="topic-item"
          [class.active]="selectedTopicId() === topic.id"
          [class.resolved]="$any(topic).isResolved"
          (click)="topicSelected.emit(topic)"
        >
          <div class="topic-severity" [style.background]="getSeverityColor(topic.severity)"></div>
          <div class="topic-content">
            <div class="topic-title">
              {{ topic.problemSummary }}
              @if ($any(topic).isResolved) {
                <span class="resolved-check">✓</span>
              }
            </div>
            <div class="topic-info">
              <span>{{ getCategoryIcon(topic.primaryTopic) }} {{ getCategoryLabelKey(topic.primaryTopic) | translate }}</span>
              <span>{{ formatTimeAgo(topic.lastUpdatedDate) }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  }
  <button type="button" class="new-topic-btn" (click)="newConversation.emit()">
    {{ 'app.components.parentAiAssistant.startNewConversation' | translate }}
  </button>
</div>
